import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import axios from 'axios';
import { API_BASE_URL } from '../api/contests';

interface PassphraseCheckProps {
  onAccessGranted: () => void;
}

const PassphraseCheck: React.FC<PassphraseCheckProps> = ({ onAccessGranted }) => {
  const [passphrase, setPassphrase] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  const checkPassphrase = async () => {
    try {
      const response = await axios.post(`${API_BASE_URL}/validate-passphrase`, { passphrase });

      if (response.data.authenticated) {
        onAccessGranted(); // If authenticated, grant access
      } else {
        setErrorMessage('Invalid passphrase. Please try again.');
      }
    } catch (error) {
      setErrorMessage('Error validating passphrase. Please try again.');
    }
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Enter Admin Passphrase
      </Typography>
      <TextField
        label="Passphrase"
        type="password"
        value={passphrase}
        onChange={(e) => setPassphrase(e.target.value)}
        fullWidth
        margin="normal"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            checkPassphrase();
          }
        }}
      />

      {errorMessage && <Typography color="error">{errorMessage}</Typography>}
      <Button
        variant="contained"
        color="primary"
        onClick={checkPassphrase}
        style={{ marginTop: '16px' }}
      >
        Submit
      </Button>
    </Box>
  );
};

export default PassphraseCheck;
